/* eslint-disable */
import { useState, useEffect } from 'react';
import { Button, Divider, Modal, CardContent, Stack, TextField, Box, Typography } from '@mui/material';
import MainCard from 'components/MainCard';
import { Controller, useForm } from 'react-hook-form';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { getEquipmentsById } from 'components/axios/equipmentAxios';
import { useSelector } from 'react-redux';
import { CustomMuiDateTimePicker } from 'components/date_picker/CustomMuiDateTimePicker';
import { customFileAxios } from 'components/axios/customAxios';
import dayjs from 'dayjs';
import EquipmentAutocomplete from 'components/EquipmentAutocomplete';
import { useTranslation } from 'react-i18next';
import { isValidDateTimeFormat } from 'components/date_picker/dateUtils';
import PermissionButton from 'components/PermissionButton';
import { PERMISSIONS } from 'config/permissions';

const InspectionModal = ({ id, onRefresh, type }) => {
    const { t } = useTranslation();
    const { name } = useSelector(state => state.user);

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose: () => {},
            message: alertMessage,
        });
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => { setOpen(true); };
    const handleClose = () => setOpen(false);

    const { control, register, handleSubmit, reset, setValue, formState: { isDirty, errors } } = useForm({});

    const regexDateTime = RegExp(/^\d{4}.(0[1-9]|1[012]).(0[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[1-9]|[0-5][0-9])$/);

    useEffect(() => {
      if (open && id) {
        const fetchDetail = async () => {
          try {
            const res = await getEquipmentsById(id);
            const data = {equipmentId : res.id, equipmentName: res.name, equipmentNo: res.equipmentNo, stationName : res.station?.name, subwayLine:res.station?.workingPart?.subwayLine};
            setValue('equipment', data);
            // setInputValue(`${res.station?.name} - ${res.name}`);
            // setOptions([data]);
          } catch (e) {
            console.error(e);
          }
        };
        fetchDetail();
      }
    }, [open, id]);
    
    useEffect(() => {
      if (open) {
        const now = dayjs().tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DDTHH:mm:ssZ');
        // console.log(now)
        setValue("alertedAt", now);
      }
    }, [open]);

    const onSubmit = (data, e) => {
      console.log(data) 

      if (data.alertedAt != null && data.alertedAt != '' && !isValidDateTimeFormat(data.alertedAt)) {
        handleAlertClick(t('message.common.alert.msg.enter.inspection.datetime.accurate'));
        return;
      }

      // const alertedAt = data.alertedAt;
      const alertedAt = dayjs(data.alertedAt).format("YYYY-MM-DDTHH:mm:ssZ");
      let dto = {
        equipment: { id: data?.equipment?.equipmentId },
        alertedAt: alertedAt,
        alertType: "MON", // 기계관제
        alertCategory: "MNT_IR",  // 점검요청
        alertDtl: data.alertDtl,
        status: "D",
        chkedAt: alertedAt,
        chkUser: name,
        statusReport: { reportYmd: null },
        fieldStatusReport: { reportYmd: null }
      };

      let formData = new FormData();
      formData.append("dto", new Blob([JSON.stringify(dto)], { type: "application/json" }));
console.log(dto)
      openModal(modals.confirmModal, {
        onSubmit: (value) => {
          customFileAxios.post(`/api/equipmentAlerts`, formData).then((res) => {
              handleAlertClick(t('message.common.alert.write.done'));
              if (onRefresh) {
                onRefresh();
              }
              reset();
              // setInputValue("");
              handleClose();
          }).catch((err) => {
              console.log(err);
              handleAlertClick(err.response?.data?.message || err.message);
          });
        },
        onClose: () => { console.log('close'); },
        message: t('message.common.alert.write.question'),
      });
    };

    return (
      <>
        {type && type === 'icon' &&
          <PermissionButton
              permission={PERMISSIONS.INSPECTION_WRITE}
              variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset", backgroundColor:"unset"}}
          >
              <span className="icon_svg" style={{ color: "#d3e0ec" }}>
                <svg className="ic" width="20" height="20">
                  <use href="#i-fault-report" />
                </svg>
              </span>
          </PermissionButton>
        }
        {(type === null || type === undefined || type === 'button') &&
          <PermissionButton
              permission={PERMISSIONS.INSPECTION_WRITE}
              className="pop_style_btn"
              type="button"
              data-ledger-asset={id}
              onClick={handleOpen}
              style={{
                height: "35px",
                minHeight: "35px"
              }}
          >
              <span>{t('message.common.btn.inspection.request')}</span>
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                style={{ display: "block", flexShrink: 0 }}
              >
                <path d="M7 17 17 7M8 7h9v9" />
              </svg>
          </PermissionButton>
        }

        <Modal className="pop_box pop_box1 renew_pop_box" open={open} onClose={handleClose}>
          <MainCard title="" modal darkTitle content={false} sx={{ width: 500 }}>
            <div className="modal-header">🚨 {t('message.common.btn.inspection.request')}</div>
            <CardContent>
              <form onSubmit={handleSubmit(onSubmit)}>
                
                {/* 대상 설비 검색 */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>
                    {t('message.common.subtitle.target.equipment')} (Equipment)
                  </Typography>

                  <EquipmentAutocomplete control={control} name="equipment" />
                </Box>

                {/* 등록 일시 */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>
                    {t('message.common.subtitle.inspection.request.datetime')}
                  </Typography>

                  <Controller
                    control={control}
                    name="alertedAt"
                    // rules={{ required: "점검 요청 등록 일시를 입력하십시오." }}
                    // 💡 여기에 규칙을 선언해야 등록 버튼을 눌렀을 때 서브밋을 완벽히 차단합니다!
                    rules={{
                        required: t('message.common.alert.msg.enter.inspection.datetime'),
                        validate: (value) => {
                            if (!value) return true;
                            // 만약 서버 포맷(T 포함)으로 이미 정제된 값이라면 통과
                            if (value.includes("T")) return true; 
                            
                            // 사용자가 입력창에 남겨둔 임시 텍스트 검증
                            const normalized = value.trim().replace(/-/g, ".");
                            const parsed = dayjs(normalized, "YYYY.MM.DD HH:mm", true);
                            
                            return (normalized.length === 16 && parsed.isValid()) || t('message.common.error.text.msg.invalid.date.format');
                        }
                    }}
                    render={({ field, fieldState }) => (
                      <CustomMuiDateTimePicker field={field} fieldState={fieldState} />
                    )}
                  />
                </Box>

                {/* 상세 내용 */}
                <Box>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>
                    {t('message.common.subtitle.alarm.details')}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    {...register("alertDtl", { required: t('message.common.alert.msg.enter.alarm.details') })} 
                    rows={4}
                    placeholder={t('message.common.text.placeholder.cause.or.notes')}
                    sx={{
                      textarea: { color: "#e2e8f0" },
                      "& .MuiOutlinedInput-root": { backgroundColor: "#0f172a" },
                    }}
                  />
                  {errors.alertDtl && <small role="alert"><br/>{errors.alertDtl.message}</small>}
                </Box>

                <Divider />
                <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
                  <Button type="submit" variant="contained" size="small">{t('message.common.btn.write')}</Button>
                  <Button
                    variant="contained"
                    className="btn_gray"
                    size="small"
                    onClick={handleClose}
                    sx={{
                      backgroundColor: "#303c4d",
                      color: "#e2e8f0",
                      border: "1px solid #465972",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "#40536b",
                        boxShadow: "none"
                      }
                    }}
                  >
                    {t('message.common.btn.cancel')}
                  </Button>
                </Stack>
              </form>
            </CardContent>
          </MainCard>
        </Modal>
      </>
    );
};

export default InspectionModal;